import { Component, OnInit, ChangeDetectionStrategy, Injector, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { DialogAbstractComponent } from '../../../shared/dialogs/dialog.class';
import { GlobalValidators } from '../../../utils/validators';

@Component({
  selector: 'app-mobile-confirmation',
  templateUrl: './mobile-confirmation.component.html',
  styleUrls: ['./mobile-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileConfirmationComponent extends DialogAbstractComponent implements OnInit {
  currentUser: any;
  confirmMobileFG: FormGroup;
  verifySignupFG: FormGroup;
  sentVerification: boolean;
  sendingCodeInProgress: boolean;
  verifyingCodeInProgress: boolean;
  verifySuccessMsg: boolean;
  verifySignupErrors: any;
  constructor(
    injector: Injector,
    private accountService: AccountService,
    private fb: FormBuilder,
    private router: Router,
    private cdRef: ChangeDetectorRef
  ) {
    super(injector);
  }

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();
    this.bindConfirmMobileForm();
    this.cdRef.detectChanges();
    // this.bindVerifySignupForm();
  }
  bindConfirmMobileForm() {
    this.confirmMobileFG = this.fb.group({
      mobile: [this.currentUser.formattedMobileNumber || '', [GlobalValidators.required]],
      mobilePhoneCountryCode: [this.currentUser.mobilePhoneCountryCode || '', [GlobalValidators.required]],
      mobilePhoneAreaCode: [this.currentUser.mobilePhoneAreaCode || '', [GlobalValidators.required]],
      mobilePhoneNumber: [this.currentUser.mobilePhoneNumber || '', [GlobalValidators.required]],
    });
    this.confirmMobileFG.valueChanges.subscribe((value) => {
      this.verifySignupErrors = undefined;
      if (this.verifySignupFG) {
        this.verifySignupFG.get('verificationCode').setValue(null);
      }
    });
  }
  bindVerifySignupForm() {
    this.verifySignupFG = this.fb.group({
      mobilePhoneCountryCode: [this.currentUser.mobilePhoneCountryCode || '', [GlobalValidators.required]],
      mobilePhoneAreaCode: [this.currentUser.mobilePhoneAreaCode || '', [GlobalValidators.required]],
      mobilePhoneNumber: [this.currentUser.mobilePhoneNumber || '', [GlobalValidators.required]],
      verificationCode: ['', [GlobalValidators.required]],
    });
  }

  async confirmEmail(form) {
    if (form.invalid) {
      this.sendingCodeInProgress = false;
      return;
    }
    this.bindVerifySignupForm();
    this.sendingCodeInProgress = true;
    try {
      this.sendingCodeInProgress = true;
      this.sentVerification = false;
      this.accountService.sendMobileConfirmation({
        mobilePhoneCountryCode: form.value.mobilePhoneCountryCode,
        mobilePhoneAreaCode: form.value.mobilePhoneAreaCode,
        mobilePhoneNumber: form.value.mobilePhoneNumber,
      });
      this.sendingCodeInProgress = false;
      this.sentVerification = true;
    } catch (e) {
      this.sendingCodeInProgress = false;
    }
    this.cdRef.detectChanges();
  }
  onVerifySignup(form) {
    if (form.invalid) {
      this.verifyingCodeInProgress = false;
      return;
    }
    this.verifyingCodeInProgress = true;
    this.verifySignupErrors = '';
    try {
      this.accountService.verifyMobileConfirmation({
        mobilePhoneCountryCode: form.value.mobilePhoneCountryCode,
        mobilePhoneAreaCode: form.value.mobilePhoneAreaCode,
        mobilePhoneNumber: form.value.mobilePhoneNumber,
        verificationCode: form.value.verificationCode,
        password: '',
      });
      this.closeDialog(true);
    } catch (e) {
      this.verifySignupErrors = ['Incorrect verification code'];
      this.verifyingCodeInProgress = false;
    }
  }
  async logout() {
    await this.accountService.signOut().then((data) => {
      this.closeDialog();
      this.router.navigate(['/signin']);
    });
  }
  closeWindow() {
    this.closeDialog(false);
  }
}
